import { render } from "./InstrumentsUpdateModal.vue?vue&type=template&id=0a5dce1f&scoped=true"
import script from "./InstrumentsUpdateModal.vue?vue&type=script&lang=js"
export * from "./InstrumentsUpdateModal.vue?vue&type=script&lang=js"

import "./InstrumentsUpdateModal.vue?vue&type=style&index=0&id=0a5dce1f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a5dce1f"]])

export default __exports__